import React from "react";
// import api from "../api";
import { Container, Alert, Jumbotron } from "react-bootstrap";

const Info = () => {
  let dir = "";
  // if (api.server !== "http://localhost:8080") {
  //   dir = ""; // /oxyspa/
  // }

  return (
    <React.Fragment>
      <Container className="mb-4">
        <Alert variant={"primary"}>Company Info</Alert>
        <div>
          <img
            src={dir + "cleanRoom.png"}
            alt="Chaban Medical Clean Room"
            align="right"
            hspace="15"
          />
          <p>
            Chaban Medical, a subsidiary of Chaban Group was established in 2003
            in order to answers the growing market demand for an independent,
            comprehensive subcontractor for manufacturing electronic systems in
            accordance with the most stringent medical standards.
          </p>
          <p>
            Chaban Medical is certified by the U.S. Food and Drug Administration
            (FDA) and holds the CE Marking of the European Union. The company
            has been inspected and certified by the Standards Institute of
            Israel (SII) and KEMA (Holland), as well as the FDA.
          </p>
          <p>
            Benefiting significantly from its relationship in the Chaban Group.
            The company capitalizes on the reputation and vast experience of
            additional Chaban Group divisions that supply solid technological
            infrastructure and full logistic support.
          </p>
          <p>
            Chaban Medical provides superior engineering capability compliant
            with medical standards, affording customers a combination of proven,
            independent production.
          </p>
          <p>
            Further, the company delivers the ability to upgrade, modify, and
            improve its products to meet customer requirements.
          </p>
          <img
            src={dir + "medicalAssemblyLine.png"}
            alt="Chaban Medical Assembly Line"
            align="left"
            hspace="15"
          />
          <p>
            Chaban Medical makes optimal use of subcontractors, carefully
            approved by the company. These subcontractors increase Chaban
            Medical's production rate flexibility in overcoming supply
            limitations and assist the company to meet short time-to-market
            delivery schedules.
          </p>
          <p>
            Chaban Medical holds all rights to the oxygen concentration Oxy-Tec
            5, which was upgraded and sold to customers in Israel (Yad Sarah and
            Cleanetica) and marketed in Poland and Germany.
          </p>
          <p>
            Chaban Medical clients include a diverse variety of medical
            equipment manufacturers including Omrix (operating as part of the
            Medical Device & Diagnostics Sector at Johnson & Johnson), Venus
            Concept, ACMI and Stryker in the U.S., and others.
          </p>
          <br />
        </div>

        <Alert variant={"primary"}>Oxy-Tec 5S Oxygen Concentrator</Alert>
        <div>
          <p>
            The Oxy-Tec 5S oxygen concentrator, is a patient-administered,
            continuously working homecare product, stationery or mobile, for
            chronic obstructive lung disease (COLD). Oxy-Tec 5S is intended for
            use by the patient outside the medical clinic or hospital, in the
            continually developing realm of homecare medical treatment.
          </p>
          <img
            src={dir + "oxytec5s.png"}
            alt="Oxy-Tec 5S oxygen concentrator"
            align="right"
            hspace="15"
          />
          <p>
            Oxy-Tec 5S oxygen concentrator has been specially developed to
            provide a dependable, convenient source of supplemental oxygen for
            therapeutic needs.
          </p>
          <p>
            Suitable for both children and adults, Oxy-Tec 5S offers
            concentration up to 96% and flow rates reaching 5 LPM.
          </p>
          <p>
            Oxy-Tec 5S separates and concentrates oxygen from ambient room air
            for delivery to a patient requiring low flow oxygen therapy. Oxygen
            from the air is concentrated using a process of molecular sieves and
            a pressure alternating system.
          </p>
          <p>
            Convenient and lightweight, Oxy-Tec 5S eliminates the need to drag
            around bulky, unmanageable oxygen cylinders and their refill
            cylinders.
          </p>
          <p>
            Chaban Medical's Oxy-Tec 5S offers users essential advantages that
            contribute to better health and quality of life. Oxy-Tec 5S can be
            conveniently used in home care settings, hospitals, clinics, and
            assisted living centers/nursing homes.
          </p>
        </div>
        <Jumbotron>
          <li>
            Ensure proper operation by the patient – preventing operation
            failures.
          </li>
          <li>Preventing malfunctions.</li>
          <li>Reducing supplier response times for failures.</li>
          <li>
            Characterization of malfunctions and the manner of handling them
            remotely.
          </li>
          <li>
            Monitor system maintenance and general data such as oxygen level,
            flow rate, hour counter, filters exchanging time, compressor
            maintenance et cetera, in order to have preventing maintenance
            instead of failure maintenance.
          </li>
        </Jumbotron>
      </Container>
      <Container className="mb-4">
        <div>
          &nbsp; <br /> &nbsp;
        </div>
        <div>
          &nbsp; <br /> &nbsp;
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Info;
